import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { capToggleStatusBar } from '@exchange/libs/utils/capacitor/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'XInputNumber',
  setup(__props) {

const onToggleInputState = (value: boolean) => {
  capToggleStatusBar(value);
};

return (_ctx: any,_cache: any) => {
  const _component_ot_input_number = _resolveComponent("ot-input-number")!

  return (_openBlock(), _createBlock(_component_ot_input_number, _mergeProps({ class: "x-input-number" }, _ctx.$attrs, { onToggleInputState: onToggleInputState }), _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (_, slot) => {
      return {
        name: slot,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope)))
        ])
      }
    })
  ]), 1040))
}
}

})